import Cookies from 'js-cookie'

const TokenKey = 'hdcs'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  console.log(22222)
  return Cookies.remove(TokenKey)
}
//获取cookie
export function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if(arr = document.cookie.match(reg)) {
    var data = unescape(arr[2]);
    return data;
  } else {
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js